import { ENGT_CHAT } from 'js/bot.model';
import { headerIcon, setter } from './headerIcon.model';
import { HeaderIconTemplate } from './headerIcon.template';

export default class HeaderIcon {
	constructor(props) {
		setter(props);

		this.init();
		this.html = HeaderIconTemplate(headerIcon);
	}

	init() {
		setter({
			img: ENGT_CHAT.get('config.chat_header_icon_url'),
		});
	}

	render() {
		return this.html;
	}
}
